import { render, staticRenderFns } from "./cara-kerja.vue?vue&type=template&id=4a04a316&scoped=true"
import script from "./cara-kerja.vue?vue&type=script&lang=js"
export * from "./cara-kerja.vue?vue&type=script&lang=js"
import style0 from "./cara-kerja.vue?vue&type=style&index=0&id=4a04a316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04a316",
  null
  
)

export default component.exports